import { html } from 'lit';
import { ZoomOut } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-zoom-out')
export class PdsIconZoomOut extends PdsIcon {
  @state()
  icon = ZoomOut;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
